export default "__VITE_ASSET__8793285f__"